import apiService from '@/services/api.service'
import store from '@/store'

export default {

    async getHotel(params) {
        const lang = store.state.locale;
        return new Promise((resolve, reject) => {
            apiService.getFrApi({
                url: 'wizard/getHotel',
                method: 'get',
                params: params,
                locale: lang
            }).then(response => {
                if (response.data.data){
                    resolve(response.data.data);
                } else {
                    reject('empty claims!')
                }
            }).catch((error) => {
                reject(error)
            })
        })
    },

}
